import { ITopologyConfigurationBuilderBase } from "./ITopologyConfigurationBuilderBase.js";

export interface ITopologyConfigurationBuilder extends ITopologyConfigurationBuilderBase<ITopologyConfigurationBuilder> {

}
